import { compose, withProps } from 'recompose';

import ExternalRedirect from 'app/router/ExternalRedirect';
import { HOME_PATH } from 'app/router/constants/paths';
import withLocale from 'app/features/localization/enhancers/withLocale';

const HomeRedirect = compose(
  withLocale,
  withProps({ to: HOME_PATH }),
)(ExternalRedirect);

export default HomeRedirect;
